export default __webpack_public_path__ + "static/media/car.7123bf71.ogg";